import { render, staticRenderFns } from "./LastUpgrades.vue?vue&type=template&id=8c90a250&"
import script from "./LastUpgrades.vue?vue&type=script&lang=ts&"
export * from "./LastUpgrades.vue?vue&type=script&lang=ts&"
import style0 from "./LastUpgrades.vue?vue&type=style&index=0&id=8c90a250&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports